import { IStores } from "./index";
import * as services from "services";
import { ListStoreConstructor } from "./ListStoreConstructor";
import { RubOperationContent } from "interfaces";

export class RubOperationList extends ListStoreConstructor<RubOperationContent> {
  constructor(stores: IStores) {
    super(
      stores,
      (params) => {
        return services.getRubOperations(params).then((response: any) => {
          return { ...response, content: response.content || [] };
        });
      },
      {
        pollingInterval: 30000,
        sorters: { date: "desc" },
      }
    );
  }
}
